export default __webpack_public_path__ + "static/media/social.d4ca468a.webp";